import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { Spin, Col, Row, Empty, Button } from 'antd'
import CustomPagination from 'pages/files/pagination'
import Categories from 'pages/files/categories'
import Card from 'components/kit/widgets/General/Card'
import _ from 'lodash'
import { antIcon } from 'components/icons'

import { arrayConverter, formatDate, bytesToMegaBytes } from 'services/utils'

// mapStateToProps redux-saga
const mapStateToProps = ({ files }) => ({ files })

const EcommerceProductCatalog = ({ dispatch, files }) => {
  const { loading, data, count, current, limit, totalSize, categories } = files
  const [selectedFiles, setSelectedFiles] = useState([])
  const filesSize = _.size(files.data)
  const [isFirstLoad, setFirstLoad] = useState(0)
  // Start the fetching of the files
  useEffect(() => {
    // Avoid loading data every time
    if (filesSize === 0 && isFirstLoad === 0) {
      dispatch({
        type: 'files/LOAD_CATEGORIES',
      })
      dispatch({
        type: 'files/LOAD_FILES',
        payload: {
          page: 1,
          limit: 10,
        },
      })
      setFirstLoad(1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files.data, count])

  const onToggleCheck = (e, etag) => {
    const tempFiles = selectedFiles
    if (e.target.checked === false) {
      _.remove(tempFiles, item => item.etag === etag)
    } else {
      tempFiles.push({ etag })
    }
    // [...tempFiles] in order for the state to change and update the UI
    setSelectedFiles([...tempFiles])
  }

  const onDelete = (fileId, filename) => {
    dispatch({
      type: 'files/DELETE_FILE',
      payload: {
        id: fileId,
        name: filename,
      },
    })
  }

  const onDownload = filename => {
    dispatch({
      type: 'files/DOWNLOAD_FILE',
      payload: {
        name: filename,
      },
    })
  }

  const onEdit = (newFileName, oldFileName) => {
    dispatch({
      type: 'files/EDIT_FILE',
      payload: {
        name: newFileName,
        old_name: oldFileName,
      },
    })
  }

  return (
    <div>
      <Helmet title="Files: List" />
      <Categories dispatch={dispatch} categoryList={categories} />
      <div className="cui__utils__heading">
        {categories.map(category => console.log(category))}
        <strong>
          <span style={{ color: 'red' }}>{count} </span> Files in total / Taking
          <span style={{ color: 'red' }}> {bytesToMegaBytes(totalSize)} </span> MBs on disk
        </strong>
      </div>
      <CustomPagination dispatch={dispatch} count={count} current={current} limit={limit}>
        {selectedFiles.length > 0 ? (
          <Row className="mb-3" justify="center">
            <Col className="me-3">
              <Button>Download</Button>
            </Col>
            <Col>
              <Button>Delete</Button>
            </Col>
          </Row>
        ) : null}
        <Spin indicator={antIcon} tip="Fetching files..." spinning={loading}>
          <div className="row">
            {count === 0 && data.length === 0 ? (
              <Col span={24}>
                <Empty description={<span>Please, upload your first files</span>} />
              </Col>
            ) : (
              data.map(file => {
                const { name, size, thumbnails, tags } = file
                return (
                  <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12" key={`doc_${file._id}`}>
                    <Card
                      id={file._id}
                      image={arrayConverter(thumbnails[0].data)}
                      creationDate={formatDate(file.creationDate)}
                      name={name}
                      price={size}
                      tags={tags}
                      etag={file.externalId}
                      onToggleCheck={onToggleCheck}
                      onDownload={onDownload}
                      onDelete={onDelete}
                      onEdit={onEdit}
                    />
                  </div>
                )
              })
            )}
          </div>
        </Spin>
      </CustomPagination>
    </div>
  )
}

export default connect(mapStateToProps)(EcommerceProductCatalog)
